import Editor from './Partials/Editor';

export default function DisplayName({ description }) {
	if (!description || !description.length) {
		return false;
	}

	return <Editor id="slp-description" className="container" content={description} />;
}
